<template>
  <div>
    <h4 class="text-center">
      <img :src="icon" class="w-30-p rounded mr-2"/>
      <span class="align-bottom">Smartsupp</span>
    </h4>

    <form class="mt-5" @submit.prevent="promiseButton = authorizeIntegration()">

      <spinner v-if="loadingChannels"></spinner>
      <form-select v-else
                   :disabled="$route.params.id || $route.query.channelId"
                   label="Channel"
                   :value="selectedChannel"
                   :error="errors.channel"
                   @form-select="selectedChannel = $event">
        <option slot="options"
                :value="null">
          Select a channel
        </option>

        <option slot="options"
                v-for="channel in channels" :key="channel.id" :value="channel.id">
          {{ channel.name }}
        </option>
      </form-select>

      <div v-if="channelHasSmartsupp" class="row">
        <div class="alert alert-danger col-12">
          This channel already has Smartsupp connected.
        </div>
      </div>

      <div v-if="errors._general" class="row">
        <div class="alert alert-danger col-12">
          {{ errors._general }}
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 d-flex justify-content-center">
          <!-- not using the v-busy-button directive here because we want to manage the button's disabled status manually -->
          <button class="btn btn-primary px-5"
                  ref="connectButton"
                  :disabled="channelHasSmartsupp">
            Connect
          </button>
        </div>
      </div>
    </form>

  </div>
</template>

<script>
  import { SMARTSUPP_INTEGRATION } from '@/utils/integration.constants'
  import FormSelect from '@/components/administration/common/form/FormSelect'
  import channelService from '@/services/amio-api/channel.service'
  import formValidatorMixin from '@/mixins/form-validator.mixin'
  import Spinner from 'vue-simple-spinner'
  import any from 'ramda/src/any'
  import * as Ladda from 'ladda'
  import 'ladda/css/ladda-themed.scss'

  export default {
    mixins: [formValidatorMixin],

    components: {
      'form-select': FormSelect,
      'spinner': Spinner
    },

    data() {
      return {
        channels: [],
        errors: {
          access_token: false,
          name: false
        },
        form: {
          channelId: this.$route.params.id || this.$route.query.channelId || null
        },
        icon: SMARTSUPP_INTEGRATION.icon,
        loadingChannels: false,
        promiseButton: null,
        selectedChannel: this.$route.params.id || this.$route.query.channelId || null,
        channelHasSmartsupp: false,
        laddaButton: null
      }
    },

    computed: {
      clientId: () => process.env.VUE_APP_SMARTSUPP_CLIENT_ID
    },

    methods: {
      async authorizeIntegration() {
        this.formValidator_clearErrors()

        const { channelId } = this.form
        if (!channelId) {
          this.errors.channel = 'Please select a Channel.'
        }

        if (this.errors.channel) return

        const dateSignature = new Date(Date.now()).toLocaleString().split(',')[0]
        const state = [SMARTSUPP_INTEGRATION.type, channelId, dateSignature].join('-')
        const redirectUri = window.location.origin + '/administration/integrations/smartsupp-auth-flow'
        const authUrl = `https://app.smartsupp.com/oauth/authorize?client_id=${this.clientId}&response_type=code&state=${state}&redirect_uri=${redirectUri}`
        window.location.href = authUrl
      },

      clearConnectPromise() {
        this.promiseButton = null
        this.laddaButton.stop()
        this.laddaButton = null
      },

      getChannels() {
        this.loadingChannels = true
        return channelService.list({offset: 0, max: 999})
          .then(({items}) => {
            this.channels = items
            this.loadingChannels = false
          })
          .catch(() => {
            this.loadingChannels = false
          })
      },

      checkSelectedChannel() {
        this.form.channelId = this.selectedChannel
        this.formValidator_clearErrors()
        if (!this.selectedChannel) {
          return
        }

        this.channelHasSmartsupp = false // need to reset the state here, otherwise ladda.stop() will un-disable the button
        this.promiseButton = channelService.getIntegrations(this.selectedChannel)
          .then(integrations => {
            this.clearConnectPromise()
            this.channelHasSmartsupp = any(it => { return it.type === 'smartsupp' }, integrations.items)
          })
          .catch(() => {
            this.clearConnectPromise()
          })
      }
    },

    watch: {
      selectedChannel: function () {
        this.checkSelectedChannel()
      },

      promiseButton: function () {
        // start busy button whenever there's a promise waiting to be resolved
        // the busy button must be cleared manually by calling this.clearConnectPromise()
        if (this.promiseButton) {
          this.laddaButton = Ladda.create(this.$refs.connectButton)
          this.laddaButton.start()
        }
      }
    },

    mounted() {
      this.getChannels()
      this.checkSelectedChannel()
    }

  }
</script>
